export default function setupTableScroll() {
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-scroll]')
    if (!button) return

    const container = document.querySelector(button.dataset.scrollTarget)
    const columns = Array.from(container.querySelectorAll('[data-scroll-column]'))
    const offsets = columns.map(column => column.offsetLeft - columns[0].offsetLeft)
    const current = container.scrollLeft
    let left

    switch (button.dataset.scroll) {
      case 'start':
        left = 0
        break
      case 'previous':
        left = offsets.reverse().find(offset => offset < current - 1)
        if (left === undefined) left = 0
        break
      case 'next':
        left = offsets.find(offset => offset > current + 1)
        if (left === undefined) left = container.scrollWidth
        break
      case 'end':
        left = container.scrollWidth
        break
    }

    container.scrollTo({left, behavior: 'smooth'})
  })

  document.addEventListener('turbo:load', alignStickyColumns)
  document.addEventListener('turbo:morph', alignStickyColumns)
  window.addEventListener('resize', alignStickyColumns)
}

function alignStickyColumns() {
  document.querySelectorAll('.table-sticky-columns').forEach(table => {
    const [first, second] = table.rows[0].cells

    table.style.setProperty('--sticky-column-1', `${first.getBoundingClientRect().width}px`)
    table.style.setProperty('--sticky-column-2', `${second.getBoundingClientRect().width}px`)
  })
}
